<template>
  <div class="company-list">
    <div v-if="companies.length > 0">
      <div class="row mb-5">
        <div class="col-12">
          <input
            type="text"
            class="form-control wfh-version m-auto"
            placeholder='Try searching "Fave" or "Malaysia"'
            v-model="q"
            v-bind:class="{ 'bg-white': origin !== 'dashboard' }"
          />
        </div>
      </div>
      <div class="row">
        <div
          class="col-12 col-md-6 col-lg-4"
          v-for="(company, key) in companies"
          :key="company.id"
        >
          <div class="company-list-card">
            <div class="company-details">
              <div class="company-image">
                <img
                  v-if="company.logo_src"
                  v-bind:src="company.logo_src"
                  alt="Company Logo"
                  style="width: 100%"
                  @click="getCompanyDetail(company.id)"
                />
              </div>

              <div class="company-rating">
                <div class="company-name" @click="getCompanyDetail(company.id)">
                  <p v-text="company.name"></p>
                </div>
                <div class="company-follow">
                  <!-- Need to display button follow/unfollow based on list of companies -->
                  <button
                    class="btn btn-follow"
                    v-bind:class="{
                      'btn-follow__following': !company.is_following,
                      'btn-follow__unfollow': company.is_following,
                    }"
                    @click="toggleFollow(key)"
                  >
                    {{ company.is_following ? "Unfollow" : "Follow" }}
                  </button>
                </div>
                <div
                  style="margin-top: 16px"
                  class="d-md-block d-none"
                  v-if="parseInt(rating(company)) > 70"
                >
                  <div
                    class="green-rating"
                    v-for="i in Math.floor(parseInt(rating(company)) / 10)"
                    :key="`green-${i}`"
                  ></div>
                  <div
                    class="null-rating"
                    v-for="i in 10 - Math.floor(parseInt(rating(company)) / 10)"
                    :key="`null-green-${i}`"
                  ></div>
                </div>
                <div
                  style="margin-top: 16px"
                  class="d-md-block d-none"
                  v-else-if="parseInt(rating(company)) > 30"
                >
                  <div
                    class="yellow-rating"
                    v-for="i in Math.floor(parseInt(rating(company)) / 10)"
                    :key="`yellow-${i}`"
                  ></div>
                  <div
                    class="null-rating margin-top: 16px"
                    v-for="i in 10 - Math.floor(parseInt(rating(company)) / 10)"
                    :key="`null-yellow-${i}`"
                  ></div>
                </div>
                <div
                  style="margin-top: 16px"
                  class="d-md-block d-none"
                  v-else-if="parseInt(rating(company)) <= 30"
                >
                  <div
                    class="red-rating"
                    v-for="i in Math.floor(parseInt(rating(company)) / 10)"
                    :key="`red-${i}`"
                  ></div>
                  <div
                    class="null-rating"
                    v-for="i in 10 - Math.floor(parseInt(rating(company)) / 10)"
                    :key="`null-red-${i}`"
                  ></div>
                </div>
                <div
                  style="margin-top: 16px"
                  class="d-md-block d-none"
                  v-else-if="!parseInt(rating(company))"
                >
                  <div
                    class="null-rating"
                    v-for="i in 10"
                    :key="`null-${i}`"
                  ></div>
                </div>
                <p class="company-remote-percentage d-md-block d-none">
                  {{ rating(company) }} Remote friendly
                </p>
                <span class="updated-at d-md-none d-block"
                  >Updated {{ getReadableTime(company.updated_at) }}</span
                >
              </div>
            </div>

            <div class="row d-md-none d-block">
              <div class="col-12 actions">
                <div>
                  <div
                    style="display: inline-block; margin-top: 16px"
                    v-if="parseInt(rating(company)) > 70"
                  >
                    <div
                      class="green-rating"
                      v-for="i in Math.floor(parseInt(rating(company)) / 10)"
                      :key="`green-${i}`"
                    ></div>
                    <div
                      class="null-rating"
                      v-for="i in 10 -
                      Math.floor(parseInt(rating(company)) / 10)"
                      :key="`null-green-${i}`"
                    ></div>
                  </div>
                  <div
                    style="display: inline-block; margin-top: 16px"
                    v-else-if="parseInt(rating(company)) > 30"
                  >
                    <div
                      class="yellow-rating"
                      v-for="i in Math.floor(parseInt(rating(company)) / 10)"
                      :key="`yellow-${i}`"
                    ></div>
                    <div
                      class="null-rating margin-top: 16px"
                      v-for="i in 10 -
                      Math.floor(parseInt(rating(company)) / 10)"
                      :key="`null-yellow-${i}`"
                    ></div>
                  </div>
                  <div
                    style="display: inline-block; margin-top: 16px"
                    v-else-if="parseInt(rating(company)) <= 30"
                  >
                    <div
                      class="red-rating"
                      v-for="i in Math.floor(parseInt(rating(company)) / 10)"
                      :key="`red-${i}`"
                    ></div>
                    <div
                      class="null-rating"
                      v-for="i in 10 -
                      Math.floor(parseInt(rating(company)) / 10)"
                      :key="`null-red-${i}`"
                    ></div>
                  </div>
                  <div
                    style="display: inline-block; margin-top: 16px"
                    v-else-if="!parseInt(rating(company))"
                  >
                    <div
                      class="null-rating"
                      v-for="i in 10"
                      :key="`null-${i}`"
                    ></div>
                  </div>
                  <p class="company-remote-percentage">
                    {{ rating(company) }} Remote friendly
                  </p>
                </div>
                <button class="btn-rounded">
                  <img v-bind:src="'/images/arrow_right-white.svg'" alt="" />
                </button>
              </div>
            </div>
            <div class="company-description d-md-block d-none">
              <div class="row" style="height: 83px">
                <div class="col-6">
                  <span class="desc-heading">Location</span>
                  <p class="desc-sub">
                    {{ company.city }},
                    {{ company.country }}
                  </p>
                </div>
                <div class="col-6">
                  <span class="desc-heading">WFH Status</span>
                  <p class="desc-sub" v-text="company.allow_work_from_home"></p>
                </div>
              </div>
              <div class="row">
                <div class="col-6">
                  <span class="desc-heading">Travel</span>
                  <p class="desc-sub" v-text="company.allow_travel"></p>
                </div>
                <div class="col-6">
                  <span class="desc-heading">Visitors</span>
                  <p class="desc-sub" v-text="company.allow_visitors"></p>
                </div>
              </div>
              <div class="row">
                <div class="col-6">
                  <span class="desc-heading">Events</span>
                  <p class="desc-sub" v-text="company.allow_events"></p>
                </div>
                <div class="col-12 actions">
                  <span class="updated-at"
                    >Updated {{ getReadableTime(company.updated_at) }}</span
                  >
                  <button
                    class="btn-rounded"
                    @click="getCompanyDetail(company.id)"
                  >
                    <img v-bind:src="'/images/arrow_right-white.svg'" alt="" />
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="companies.length === 0" class="row">
        <div class="company-list-card empty"></div>
      </div>
      <div class="row">
        <button
          type="submit"
          class="btn btn-load-more m-auto"
          v-if="paginator.current_page < paginator.last_page"
          @click="getNextSetOfRecords"
        >
          Load more results...
        </button>
      </div>
    </div>
    <div class="w-100 text-center" v-else>
      You do not have following companies
    </div>
  </div>
</template>

<script>
import DropDownOptions from "./DropdownOptionsConfig";
import remoteReadinessRating from "./RemoteReadinessRating";

export default {
  props: ["origin", "only_following"],

  data() {
    return {
      data: {},
      companies: [],
      modalCurrentCompany: {},
      displayableCompanyDetails: {},
      displayableRemoteMeasures: {},
      skipKeys: [
        "id",
        "company_id",
        "needs_help_remote_ready",
        "created_at",
        "updated_at",
      ],
      dropDownOptions: DropDownOptions,
      paginator: {
        from: 1,
        last_page: 1,
        per_page: 12,
        to: 4,
        total: 4,
        current_page: 1,
      },
      q: "",
    };
  },

  watch: {
    "paginator.current_page"() {
      if (
        this.paginator.current_page > this.paginator.last_page ||
        this.paginator.current_page < 1
      )
        this.paginator.current_page = 1;

      this.getActiveCompanies();
    },

    q() {
      this.executeSearch();
    },
  },

  methods: {
    executeSearch: _.debounce(async function () {
      this.companies = [];
      await this.getActiveCompanies(true);
    }, 500),

    async getActiveCompanies(refresh = false) {
      if (refresh) {
        this.paginator = {
          from: 1,
          last_page: 1,
          per_page: 12,
          to: 4,
          total: 4,
          current_page: 1,
        };
      }

      const url =
        "/company?page=" +
        (this.paginator.current_page || 1) +
        "&q=" +
        this.q +
        (this.only_following ? "&type=following" : "");
      this.data = await axios.get(url).then((data) => data.data.data);

      this.data.data.forEach((item) => this.companies.push(item));

      const mapKeys = ["from", "last_page", "per_page", "to", "total"].forEach(
        (key) => (this.paginator[key] = this.data[key])
      );
    },

    rating(company) {
      if (!company.remote_measures) return "–";

      const score = remoteReadinessRating(company.remote_measures);

      return score + "%";
    },

    getReadableTime(updatedAt) {
      return moment(updatedAt, "YYYY-MM-DDTHH:mm:ss").fromNow();
    },

    getCompanyDetail(companyId) {
      if (this.origin && this.origin === "dashboard") {
        this.$emit("viewCompanyDetails", companyId);
      } else {
        location.href = `/company/${companyId}`;
      }
    },

    isEmptySearchResults() {
      return this.companies.length == 0 && !!this.q;
    },

    getNextSetOfRecords() {
      this.paginator.current_page++;
    },

    getPreviousSetOfRecords() {
      this.paginator.current_page--;
    },

    getPaginationText() {
      return (
        "Showing " +
        this.paginator.from +
        " – " +
        this.paginator.to +
        " out of " +
        this.paginator.total
      );
    },

    async toggleFollow(key) {
      try {
        await axios.post(`/company/${this.companies[key].id}/follow`);
        this.companies[key].is_following = !this.companies[key].is_following;
      } catch (e) {
        if (e.response.status === 401) {
          location.href = "/login";
        }
      }
    },
  },

  mounted() {
    this.getActiveCompanies();
  },
};
</script>

<style lang="scss" scoped>
.company-list-card {
  min-height: 358px;
  max-width: 365px;
  border-radius: 8px;
  background-color: #ffffff;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.15);
  margin: 0 auto 20px;
  padding: 30px;

  @media (max-width: 768px) {
    min-height: 220px;
  }

  .company-details {
    display: flex;
    margin-bottom: 20px;

    .company-image {
      border-radius: 3px;
      width: 93px;
      height: 93px;
      padding: 8px 8px 8px 0;
      margin-right: 8px;
      align-items: center;
      display: flex;
      cursor: pointer;

      img {
        width: 100%;
      }
    }

    .company-name {
      overflow: hidden;
      text-overflow: ellipsis;
      cursor: pointer;

      p {
        font-family: Lato;
        font-size: 22px;
        font-weight: bold;
        letter-spacing: 0;
        line-height: 30px;
      }
    }

    .company-rating {
      width: 213px;
    }

    .company-remote-percentage {
      color: #808fa4;
      font-family: "Open Sans", sans-serif;
      font-size: 14px;
      font-weight: 600;
      letter-spacing: 0.5px;
      line-height: 22px;
    }
  }

  .company-description {
    span {
      color: #808fa4;
      font-family: "Open Sans", sans-serif;
      font-size: 14px;
      font-weight: 400;
      letter-spacing: 0.5px;
      line-height: 22px;
    }

    p {
      color: #303030;
      font-size: 14px;
      line-height: 17px;
      font-weight: 600;
    }

    button {
      border-radius: 6px;
      border: none;
      width: auto;
      background-color: #fff;
      box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.09);
    }
  }
  .actions {
    display: flex;
    align-items: center;

    button {
      /* flex: 2; */
      width: 48px;
      height: 48px;
      border-radius: 100%;
      background: #ff375e;
      border: none;
    }
    @media (max-width: 768px) {
      justify-content: space-between;
    }
  }

  .updated-at {
    color: #303030;
    font-family: "Open Sans", sans-serif;
    font-size: 12px;
    flex: 4;
    letter-spacing: 0;
    line-height: 24px;
  }

  .btn-follow {
    width: 100%;
    color: #ffffff;
    font-family: "Open Sans", sans-serif;
    font-size: 14px;
    font-weight: bold;
    letter-spacing: 0;
    line-height: 22px;
    text-align: center;
    border-radius: 4px;

    &__following {
      background-color: #000000;
      color: #ffffff;
    }

    &__unfollow {
      color: #28282e;
      background-color: #ffffff;
      border: 1px solid #28282e;
    }
  }
}

.btn-load-more {
  height: 56px;
  width: 220px;
  border: 1px solid #28282e;
  border-radius: 4px;
}

.company-list-card.empty {
  background-color: transparent;
  border: none;
  box-shadow: none;
}

.company-list-card:hover {
  background-color: #5145ff;

  .company-details {
    .company-image {
      color: #fff;
    }

    .company-name {
      p {
        color: #fff;
      }
    }

    .company-remote-percentage {
      color: #e0e0e0;
    }
  }

  .company-description {
    .desc-heading {
      color: #fff !important;
    }

    .desc-sub {
      color: #e0e0e0 !important;
    }
  }
}
</style>
